// 서버 점검(재시작) 상태 저장소
// 프론트는 CloudFront/서비스워커 캐시로 계속 뜨지만 백엔드 재시작 중에는 API가 502/504 또는
// 무응답이 된다. 이를 감지해 점검 화면(components/ServerMaintenance)을 띄우는 전역 상태다.
import { useSyncExternalStore } from 'react';
import axios from 'axios';

const HEALTH_URL = `${(process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '')}/health`;
const DOWN_STATUSES = [502, 503, 504];

let serverDown = false;
let probing = null;
const listeners = new Set();

function setServerDown(next) {
  if (serverDown === next) return;
  serverDown = next;
  listeners.forEach((listener) => listener());
}

// 응답 자체가 없거나(네트워크 오류) 게이트웨이 계열 5xx면 서버 다운 의심으로 본다
export function isServerDownError(error) {
  if (axios.isCancel(error)) return false;
  if (!error?.response) return Boolean(error?.request);
  return DOWN_STATUSES.includes(error.response.status);
}

// /api/health 는 DB 연결까지 확인한다(서비스워커에서도 캐시하지 않는 networkOnly 경로)
export async function checkServerHealth() {
  try {
    const res = await fetch(HEALTH_URL, { cache: 'no-store' });
    return res.ok;
  } catch {
    return false;
  }
}

// 개별 API의 5xx(예: VAPID 미설정 503)를 점검으로 오인하지 않도록 헬스체크로 확정한다.
// 동시에 여러 요청이 실패해도 헬스체크는 한 번만 보낸다. 반환값: 다운 확정 여부
export function reportSuspectedOutage() {
  if (serverDown) return Promise.resolve(true);
  if (!probing) {
    probing = checkServerHealth()
      .then((ok) => {
        if (!ok) setServerDown(true);
        return !ok;
      })
      .finally(() => {
        probing = null;
      });
  }
  return probing;
}

export function markServerUp() {
  setServerDown(false);
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return serverDown;
}

export function useServerDown() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
